import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24' class={customClass}>
  <path d='M9.5 6.5L14.5 11.5L9.5 16.5L9.5 6.5Z' fill={color} />
</svg>
